<template>
  <component
    :is="tag"
    class="input-group-prepend"
  >
    <slot />
  </component>
</template>

<script>
export default {
  name: 'BInputGroupPrepend',
  props: {
    tag: {
      type: String,
      default: 'div'
    }
  }
}
</script>
